import store from '../store/store';
import { mutatorAction } from 'satcheljs';
/**
 * Called when we change Show week number checkbox, updates the new value in calendar appearance store
 * @checked: new value for show week numbers checkbox
 */
export default mutatorAction('setShowWeekNumbersOption', function setShowWeekNumbersOption(checked) {
    var optionState = store();
    optionState.showWeekNumbers = checked;
});
//# sourceMappingURL=setShowWeekNumbersOption.js.map